var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArtPharmacist2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-1"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 391.92,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.14,
    y: 389.21,
    width: 55.42,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 397.86,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.46,
    y: 391.8,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 437.56,
    y: 391.8,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.21,
    y: 395.31,
    width: 46.84,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.25,
    y: 85.06,
    width: 168.04,
    height: 297.34,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.25,
    y: 69.56,
    width: 168.04,
    height: 4.59,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.25,
    y: 69.56,
    width: 168.04,
    height: 4.59,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.72,
    y: 69.56,
    width: 168.04,
    height: 4.59,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.44,
    y: 121.56,
    width: 152.4,
    height: 9.44,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.85,
    y: 121.56,
    width: 31.45,
    height: 9.44,
    transform: "translate(423.14 252.56) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.44,
    y: 201.56,
    width: 152.4,
    height: 9.44,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.85,
    y: 201.56,
    width: 31.45,
    height: 9.44,
    transform: "translate(423.14 412.56) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.44,
    y: 281.56,
    width: 152.4,
    height: 9.44,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.85,
    y: 281.56,
    width: 31.45,
    height: 9.44,
    transform: "translate(423.14 572.56) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.47,
    y: 167.56,
    width: 32.42,
    height: 34.01,
    rx: 3.38,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.47,
    y: 171.77,
    width: 18.33,
    height: 25.46,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.99,
    y: 162.93,
    width: 17.37,
    height: 4.62,
    rx: 1.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.61,
    y: 167.56,
    width: 32.42,
    height: 34.01,
    rx: 3.38,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.61,
    y: 171.77,
    width: 18.33,
    height: 25.46,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.13,
    y: 162.93,
    width: 17.37,
    height: 4.62,
    rx: 1.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.75,
    y: 167.56,
    width: 32.42,
    height: 34.01,
    rx: 3.38,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.75,
    y: 171.77,
    width: 18.33,
    height: 25.46,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.27,
    y: 162.93,
    width: 17.37,
    height: 4.62,
    rx: 1.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.37,
    y: 103.39,
    width: 15.31,
    height: 18.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.62,
    y: 107.92,
    width: 12.6,
    height: 9.12,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.65,
    y: 99.54,
    width: 18.75,
    height: 5.26,
    rx: 1.23,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.66,
    y: 103.39,
    width: 15.31,
    height: 18.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.91,
    y: 107.92,
    width: 12.6,
    height: 9.12,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.94,
    y: 99.54,
    width: 18.75,
    height: 5.26,
    rx: 1.23,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.95,
    y: 103.39,
    width: 15.31,
    height: 18.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.2,
    y: 107.92,
    width: 12.6,
    height: 9.12,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.23,
    y: 99.54,
    width: 18.75,
    height: 5.26,
    rx: 1.23,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.23,
    y: 103.39,
    width: 15.31,
    height: 18.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.48,
    y: 107.92,
    width: 12.6,
    height: 9.12,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.51,
    y: 99.54,
    width: 18.75,
    height: 5.26,
    rx: 1.23,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.17,
    y: 252.38,
    width: 18.83,
    height: 29.18,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.17,
    y: 259.44,
    width: 14.17,
    height: 15.06,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 252.38,
    width: 8.17,
    height: 29.18,
    transform: "translate(186.17 533.94) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.17,
    y: 252.38,
    width: 18.83,
    height: 29.18,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.17,
    y: 259.44,
    width: 14.17,
    height: 15.06,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 252.38,
    width: 8.17,
    height: 29.18,
    transform: "translate(246.17 533.94) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.17,
    y: 252.38,
    width: 18.83,
    height: 29.18,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.17,
    y: 259.44,
    width: 14.17,
    height: 15.06,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149,
    y: 252.38,
    width: 8.17,
    height: 29.18,
    transform: "translate(306.17 533.94) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.17,
    y: 252.38,
    width: 18.83,
    height: 29.18,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.17,
    y: 259.44,
    width: 14.17,
    height: 15.06,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 252.38,
    width: 8.17,
    height: 29.18,
    transform: "translate(366.17 533.94) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.72,
    y: 85.06,
    width: 168.04,
    height: 297.34,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.91,
    y: 121.56,
    width: 152.4,
    height: 9.44,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.31,
    y: 121.56,
    width: 31.45,
    height: 9.44,
    transform: "translate(854.07 252.56) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.91,
    y: 201.56,
    width: 152.4,
    height: 9.44,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.31,
    y: 201.56,
    width: 31.45,
    height: 9.44,
    transform: "translate(854.07 412.56) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.91,
    y: 281.56,
    width: 152.4,
    height: 9.44,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.31,
    y: 281.56,
    width: 31.45,
    height: 9.44,
    transform: "translate(854.07 572.56) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.74,
    y: 263.42,
    width: 36.65,
    height: 18.14,
    rx: 3.82,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.74,
    y: 268.18,
    width: 20.72,
    height: 8.48,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.24,
    y: 258.19,
    width: 19.64,
    height: 5.23,
    rx: 1.19,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.64,
    y: 263.42,
    width: 36.65,
    height: 18.14,
    rx: 3.82,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.64,
    y: 268.18,
    width: 20.72,
    height: 8.48,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.15,
    y: 258.19,
    width: 19.64,
    height: 5.23,
    rx: 1.19,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.55,
    y: 263.42,
    width: 36.65,
    height: 18.14,
    rx: 3.82,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.55,
    y: 268.18,
    width: 20.72,
    height: 8.48,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.05,
    y: 258.19,
    width: 19.64,
    height: 5.23,
    rx: 1.19,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.32,
    y: 179.92,
    width: 19.67,
    height: 21.64,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.49,
    y: 185.31,
    width: 16.18,
    height: 10.86,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.11,
    y: 178.25,
    width: 24.08,
    height: 2.67,
    rx: 0.99,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.93,
    y: 179.92,
    width: 19.67,
    height: 21.64,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.11,
    y: 185.31,
    width: 16.18,
    height: 10.86,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.72,
    y: 178.25,
    width: 24.08,
    height: 2.67,
    rx: 0.99,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.55,
    y: 179.92,
    width: 19.67,
    height: 21.64,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.72,
    y: 185.31,
    width: 16.18,
    height: 10.86,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.34,
    y: 178.25,
    width: 24.08,
    height: 2.67,
    rx: 0.99,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.16,
    y: 179.92,
    width: 19.67,
    height: 21.64,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.33,
    y: 185.31,
    width: 16.18,
    height: 10.86,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.95,
    y: 178.25,
    width: 24.08,
    height: 2.67,
    rx: 0.99,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.26,
    y: 100.68,
    width: 17.21,
    height: 20.88,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.26,
    y: 105.74,
    width: 12.94,
    height: 10.77,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.47,
    y: 100.68,
    width: 7.46,
    height: 20.88,
    transform: "translate(638.4 222.24) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.67,
    y: 100.68,
    width: 17.21,
    height: 20.88,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.67,
    y: 105.74,
    width: 12.94,
    height: 10.77,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.88,
    y: 100.68,
    width: 7.46,
    height: 20.88,
    transform: "translate(693.22 222.24) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.08,
    y: 100.68,
    width: 17.21,
    height: 20.88,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.08,
    y: 105.74,
    width: 12.94,
    height: 10.77,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.29,
    y: 100.68,
    width: 7.46,
    height: 20.88,
    transform: "translate(748.04 222.24) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.49,
    y: 100.68,
    width: 17.21,
    height: 20.88,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.49,
    y: 105.74,
    width: 12.94,
    height: 10.77,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.7,
    y: 100.68,
    width: 7.46,
    height: 20.88,
    transform: "translate(802.86 222.24) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-1",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.38,97.25c-9.77,4.61-10.71,18-7,29.31,2.64,8.17-4.29,8.6-5.91,20.11a26.52,26.52,0,0,0,30.91,29.73c17.24-3.19.55-38.84,6.88-51.27S258.88,92.31,248.38,97.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.2,378.84l11.11.81c-1.53,8.85-3,22.81-3,22.81h-8.81S281.53,384.89,281.2,378.84Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.37,378.84l11,.81c-2.48,8.85-5.41,22.81-5.41,22.81h-8.81S223.06,384.89,223.37,378.84Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,411.2c7.66,0,7.11-.12,11.43-.26,3.69-.14,4.54.33,7.5.26,2.48-.05,2.56-2.42,2-5.14-.21-1.05-.54-2.27-.84-3.78a1.84,1.84,0,0,0-1.82-1.47h-8.95a2.14,2.14,0,0,0-1.7.85,12.87,12.87,0,0,1-8.9,5C265.54,407.21,267.93,411.2,271,411.2Z",
    style: {
      fill: "#278CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.85,411.2c7.66,0,7.12-.12,11.43-.26,3.69-.14,4.54.33,7.5.26,2.48-.05,2.56-2.42,2-5.14-.22-1.05-.54-2.27-.85-3.78a1.82,1.82,0,0,0-1.81-1.47h-9a2.1,2.1,0,0,0-1.69.85,12.91,12.91,0,0,1-8.9,5C205.41,407.21,207.8,411.2,210.85,411.2Z",
    style: {
      fill: "#278CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.87,206.1s-7,54.14-6.36,88.52c-2.64,32.27-6.88,94-6.88,94,.13,1.65,8.83,1,10.38,0,0,0,19.93-41.66,16.69-94,22.14-54.6,20.82-88.52,20.82-88.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.35,249.82c-1.72,7.05-3.93,14.87-6.75,23.38-.82-17.14-5.46-40.09-5.61-40.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.3,206.1s15.83,61.1,22.1,91.11c6.59,31.51,15.82,70.48,14,91.42,1.76,1,8.06,1.1,11.62,0,0,0,13.56-59.69-3.68-90,6.24-74.64-13.51-92.5-13.51-92.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.63,384.27a29.14,29.14,0,0,1-.53,4.3.88.88,0,0,0,.73,1.06c4.23.68,10.42-.31,12.39-.66a.94.94,0,0,0,.74-.74l.74-4a.87.87,0,0,0-.87-1l-12.3.24A.92.92,0,0,0,279.63,384.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.63,384.27a29.14,29.14,0,0,1-.53,4.3.88.88,0,0,0,.73,1.06c4.23.68,10.42-.31,12.39-.66a.94.94,0,0,0,.74-.74l.74-4a.87.87,0,0,0-.87-1l-12.3.24A.92.92,0,0,0,279.63,384.27Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.79,384.08c-.12,1.12-.34,3.12-.55,4.59a.87.87,0,0,0,.74,1,61.09,61.09,0,0,0,11.46-.13.93.93,0,0,0,.81-.68l1.07-4a.86.86,0,0,0-.8-1.1l-11.78-.47A.91.91,0,0,0,220.79,384.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.79,384.08c-.12,1.12-.34,3.12-.55,4.59a.87.87,0,0,0,.74,1,61.09,61.09,0,0,0,11.46-.13.93.93,0,0,0,.81-.68l1.07-4a.86.86,0,0,0-.8-1.1l-11.78-.47A.91.91,0,0,0,220.79,384.08Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.11,164.48l1.93,2.4a3.6,3.6,0,0,0,3,1.33l5.41-.32a6.67,6.67,0,0,0,5.27-3.14l.72-1.14c-2.94-4.2-9.21-6.57-9.21-6.57l-1.72-.87a3,3,0,0,0-4.06,1.21l-1.78,3.37A3.43,3.43,0,0,0,181.11,164.48Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.66,
    y: 146.72,
    width: 12.32,
    height: 14.42,
    rx: 1.47,
    transform: "translate(-27.86 42.58) rotate(-11.99)",
    style: {
      fill: "#278CFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.47,
    y: 124.36,
    width: 1,
    height: 3.59,
    transform: "translate(-41.99 143.36) rotate(-42.16)",
    style: {
      fill: "#278CFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.32,
    y: 137,
    width: 6.52,
    height: 1,
    transform: "translate(-35.45 197.87) rotate(-49.36)",
    style: {
      fill: "#278CFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.4,
    y: 128.25,
    width: 1,
    height: 15.54,
    transform: "translate(-46.3 151.91) rotate(-42.16)",
    style: {
      fill: "#278CFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.22,
    y: 137.5,
    width: 1,
    height: 13.2,
    transform: "translate(-21.52 257.92) rotate(-70.8)",
    style: {
      fill: "#278CFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.87,
    y: 144.51,
    width: 7.12,
    height: 5.74,
    rx: 0.65,
    transform: "translate(-26.53 42.15) rotate(-11.99)",
    style: {
      fill: "#278CFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.31,
    y: 141.42,
    width: 8.6,
    height: 4.24,
    rx: 0.61,
    transform: "translate(-25.75 41.9) rotate(-11.99)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.72,
    y: 149.39,
    width: 10.19,
    height: 8.2,
    transform: "translate(-27.74 42.78) rotate(-11.99)",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.6,159.56c-.29.49-.47.75-.7,1.11l-.66,1-1.32,1.87c-.89,1.24-1.81,2.43-2.76,3.6-1.9,2.33-3.88,4.6-6,6.74a67.72,67.72,0,0,1-14.43,11.36c-1.36.78-2.75,1.51-4.19,2.18l-1.09.48-.27.12-.15.07-.24.09a8.74,8.74,0,0,1-1,.34,12.34,12.34,0,0,1-4.11.51,15.3,15.3,0,0,1-6.66-1.94,27.52,27.52,0,0,1-4.55-3.15,56,56,0,0,1-6.66-6.95c-1-1.2-1.92-2.39-2.84-3.61-.46-.61-.91-1.22-1.35-1.85s-.87-1.2-1.38-2L198,162.57c.16.41.44,1.06.71,1.59s.56,1.11.86,1.66a35.27,35.27,0,0,0,1.91,3.21,30.45,30.45,0,0,0,4.38,5.42,12.15,12.15,0,0,0,2.17,1.7,3.67,3.67,0,0,0,1.2.5c.05,0,0,0,0,0h0l.09,0,.2-.09.81-.36c1.07-.5,2.13-1.06,3.17-1.66a46.44,46.44,0,0,0,5.95-4.24,57.32,57.32,0,0,0,5.37-5.21,61.42,61.42,0,0,0,4.7-6c.71-1,1.41-2.1,2.06-3.17.33-.54.64-1.07.94-1.61l.42-.79c.12-.24.29-.57.33-.69Z",
    style: {
      fill: "#278CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.6,159.56c-.29.49-.47.75-.7,1.11l-.66,1-1.32,1.87c-.89,1.24-1.81,2.43-2.76,3.6-1.9,2.33-3.88,4.6-6,6.74a67.72,67.72,0,0,1-14.43,11.36c-1.36.78-2.75,1.51-4.19,2.18l-1.09.48-.27.12-.15.07-.24.09a8.74,8.74,0,0,1-1,.34,12.34,12.34,0,0,1-4.11.51,15.3,15.3,0,0,1-6.66-1.94,27.52,27.52,0,0,1-4.55-3.15,56,56,0,0,1-6.66-6.95c-1-1.2-1.92-2.39-2.84-3.61-.46-.61-.91-1.22-1.35-1.85s-.87-1.2-1.38-2L198,162.57c.16.41.44,1.06.71,1.59s.56,1.11.86,1.66a35.27,35.27,0,0,0,1.91,3.21,30.45,30.45,0,0,0,4.38,5.42,12.15,12.15,0,0,0,2.17,1.7,3.67,3.67,0,0,0,1.2.5c.05,0,0,0,0,0h0l.09,0,.2-.09.81-.36c1.07-.5,2.13-1.06,3.17-1.66a46.44,46.44,0,0,0,5.95-4.24,57.32,57.32,0,0,0,5.37-5.21,61.42,61.42,0,0,0,4.7-6c.71-1,1.41-2.1,2.06-3.17.33-.54.64-1.07.94-1.61l.42-.79c.12-.24.29-.57.33-.69Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.16,160.3a164.4,164.4,0,0,0,.27,17.78c.32,7.72,2,15.84,4.1,28.34,4.23,2.47,25.61,1.45,39.29-.32-.83-10.95.53-23.47,7.95-48.11,1.72-5.71-2.12-11.2-8.24-11.78-1.64-.16-3.38-.29-5.16-.37a141.36,141.36,0,0,0-18.76,0c-2,.18-4.16.42-6.18.68C237.14,147.47,231.38,153.45,231.16,160.3Z",
    style: {
      fill: "#278CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.79,209.05a185.77,185.77,0,0,0,41.5-.08,1,1,0,0,0,.72-1.32c-.34-.8-.68-1.59-1-2.39a.88.88,0,0,0-.89-.55,182.28,182.28,0,0,1-39.9,0,.89.89,0,0,0-1,.83c-.09.83-.17,1.65-.25,2.48A.93.93,0,0,0,234.79,209.05Z",
    style: {
      fill: "#278CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.05,124.73c-1.63,6-3.63,17.1.29,21.13,0,0,1.19,5.91-15,5.36-12.47-.42-3.75-5.36-3.75-5.36,6.86-1.61,7.06-6.6,6.23-11.29Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.77,144.92s-7.1,6.31-9.22,21.52c-4,29.06,2.09,148.05,2.09,148.05s26-8.49,35.44-16.62c.44-8.14-15.28-83.12-13.9-104.64s4.05-40.27,1.27-44.32S268.77,144.92,268.77,144.92Z",
    style: {
      fill: "#278CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.77,144.92s-7.1,6.31-9.22,21.52c-4,29.06,2.09,148.05,2.09,148.05s26-8.49,35.44-16.62c.44-8.14-15.28-83.12-13.9-104.64s4.05-40.27,1.27-44.32S268.77,144.92,268.77,144.92Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09,145.52c-10.82,13.89-10.74,104.17-7.61,169-9.61-1.16-19.88-20.65-19.88-20.65S233,225.1,231,196s-1.72-39.31,3-44.69S250.09,145.52,250.09,145.52Z",
    style: {
      fill: "#278CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09,145.52c-10.82,13.89-10.74,104.17-7.61,169-9.61-1.16-19.88-20.65-19.88-20.65S233,225.1,231,196s-1.72-39.31,3-44.69S250.09,145.52,250.09,145.52Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.86,144.4C266,146,257.11,154,258.31,187c.9-3.73,5-21.41,9.33-29.83a5.55,5.55,0,0,0-3-1,6.19,6.19,0,0,1,3.82-.67c1.22-2.46,3.72-7.63,6.15-10.41C272,143.41,267.86,144.4,267.86,144.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.17,187s1.93-30.67,8.29-41.61a9.89,9.89,0,0,0-7.23,1.13c-1.33,1.6-3.07,7.75-3.07,9.08a4.42,4.42,0,0,1,3.05.34,10,10,0,0,0-3.13,1.17C239.66,159.28,239.46,170.87,242.17,187Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.84,182.79h-8.59a1.09,1.09,0,0,1-1-1.29l.35-4.08a1.36,1.36,0,0,1,1.22-1.3h8.59a1.1,1.1,0,0,1,1,1.3l-.36,4.08A1.35,1.35,0,0,1,272.84,182.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.81 182.79 265.47 182.79 267.27 176.12 269.61 176.12 267.81 182.79",
    style: {
      fill: "#278CFF",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.06 182.79 268.73 182.79 270.53 176.12 272.86 176.12 271.06 182.79",
    style: {
      fill: "#278CFF",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.92,176.82h0c-.42,0-.73-.24-.68-.55l.27-1.87a.8.8,0,0,1,.84-.55h0c.42,0,.73.24.69.55l-.27,1.87A.82.82,0,0,1,268.92,176.82Z",
    style: {
      fill: "#278CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.06,128.74l-7.25,5.82a19,19,0,0,1,.33,3.33c2.6-.37,6.34-3.19,6.82-5.89A9.2,9.2,0,0,0,263.06,128.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.21,112.61c-1.83,9.75-2.4,13.91-8,18.58-8.37,7-19.87,3.32-21-6.62-1-8.95,2.17-23.39,12.22-26.61A12.71,12.71,0,0,1,273.21,112.61Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.8,120.66c-2.56,0-4.7-2.6-4.8-5.87a7,7,0,0,1,1.24-4.26,4.28,4.28,0,0,1,3.32-1.89h.11c2.56,0,4.7,2.61,4.8,5.87h0c.09,3.31-2,6.07-4.56,6.15Zm-.13-11.52h-.1a3.78,3.78,0,0,0-2.92,1.68,6.37,6.37,0,0,0-1.15,4c.09,3,2.1,5.44,4.4,5.38s4.16-2.6,4.07-5.63h0C259.88,111.53,258,109.14,255.67,109.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.26,114.51a.25.25,0,0,1-.15-.05s-.76-.56-1.14-.16a.25.25,0,1,1-.36-.34c.54-.58,1.38-.21,1.8.1a.25.25,0,0,1,.05.35A.28.28,0,0,1,251.26,114.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.38,119.74c-2.56,0-4.7-2.6-4.8-5.86s1.94-6.07,4.55-6.15h.11c2.56,0,4.7,2.6,4.8,5.87s-1.94,6.07-4.55,6.14Zm-.14-11.51h-.09c-2.34.07-4.16,2.59-4.07,5.63s2,5.38,4.3,5.38h.09c2.34-.07,4.16-2.59,4.07-5.63S247.53,108.23,245.24,108.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.4,103.52c-4,8.9,2.65,13,3.64,15.8,1.39,7.72-16.2,23.05-11,47.06,7.58-13.42,18-12.78,19.13-21.81,1.13-9.3-3.53-14,1.42-22.89s6.7-19.46-2-21.11S266.4,103.52,266.4,103.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.67,155.33a.24.24,0,0,1-.19-.08.25.25,0,0,1,0-.35c5.05-4.58,5.43-10.56,5.84-16.9.27-4.15.55-8.45,2.2-12.49,2.9-7.1,5.31-17.08,2.53-21.81a5,5,0,0,0-3.89-2.52.26.26,0,0,1-.22-.28.24.24,0,0,1,.28-.22,5.45,5.45,0,0,1,4.26,2.76c2.87,4.89.59,14.71-2.5,22.26-1.62,4-1.89,8.22-2.16,12.33-.41,6.44-.8,12.52-6,17.24A.27.27,0,0,1,271.67,155.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.68,104.6c-6.59.75-18.24,0-20.92-3.42s.81-12,8.56-13.35c6.3-1.08,10.08,6.67,10.08,6.67s6-3,11.23,3.87C282.4,104.6,272,111.66,268.68,104.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.16,117.35h0l-11.05-1.9a.24.24,0,0,1-.2-.29.25.25,0,0,1,.29-.2l11,1.9a.25.25,0,0,1,0,.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.77,114.24c-.12.82-.65,1.46-1.17,1.42s-.86-.74-.75-1.56.65-1.47,1.17-1.43S257.88,113.41,257.77,114.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.81,113.65c-.12.82-.64,1.46-1.17,1.42s-.86-.74-.74-1.56.64-1.46,1.17-1.42S247.93,112.82,247.81,113.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.29,112.15l-1.86-.72S246.21,113.06,247.29,112.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.38,115.21a24.5,24.5,0,0,1-3.63,5.05c.92,1.09,2.8.76,2.8.76Z",
    style: {
      fill: "#ba4d3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.76,124.41a6.91,6.91,0,0,1-1.37,0,.23.23,0,0,1-.21-.26.26.26,0,0,1,.28-.22,6.93,6.93,0,0,0,5.58-2.17.24.24,0,0,1,.34,0,.24.24,0,0,1,0,.34A7.21,7.21,0,0,1,253.76,124.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.63,122.48a6.8,6.8,0,0,1-4.56,3.1c-2.32.32-3-2.38-1.92-4.87,1-2.24,3.33-5.1,5.46-4.27S274,120.35,272.63,122.48Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,110.56a.42.42,0,0,1-.29-.21,3.55,3.55,0,0,0-2.81-1.88.44.44,0,0,1-.44-.49.52.52,0,0,1,.53-.47,4.43,4.43,0,0,1,3.58,2.34.49.49,0,0,1-.21.65A.46.46,0,0,1,261,110.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.92,107.23a.45.45,0,0,1-.35-.78,5.08,5.08,0,0,1,4.12-1.84.45.45,0,0,1,.39.53.52.52,0,0,1-.56.43,4.07,4.07,0,0,0-3.25,1.49A.53.53,0,0,1,245.92,107.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.25,112.74l-1.86-.72S256.17,113.64,257.25,112.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.66,216.75l.71-3a3.58,3.58,0,0,1,2.13-2.5l5-2.05a6.68,6.68,0,0,1,6.11.55l1.14.72c-.84,5.05-5.47,9.9-5.47,9.9l-1.16,1.53a3,3,0,0,1-4.2.67l-3.05-2.27A3.44,3.44,0,0,1,273.66,216.75Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.39,148.21c.53.34.83.56,1.21.84l1.06.79c.69.53,1.37,1,2,1.59q2,1.6,3.87,3.32a90.86,90.86,0,0,1,7.17,7.25,71.6,71.6,0,0,1,6.26,8.23c.94,1.47,1.85,3,2.65,4.54a50.71,50.71,0,0,1,2.27,4.83l.49,1.25.06.16.11.31.19.61c.1.41.2.82.26,1.22a13.54,13.54,0,0,1,0,4.33,21.4,21.4,0,0,1-2.14,6.24,52.59,52.59,0,0,1-6,8.93c-2.11,2.67-4.33,5.13-6.58,7.54-1.13,1.2-2.25,2.4-3.41,3.57l-1.75,1.75c-.61.59-1.15,1.15-1.84,1.8L280,206.12c.51-.35,1.15-.82,1.72-1.26l1.74-1.38c1.15-.93,2.3-1.87,3.4-2.87a78.16,78.16,0,0,0,6.19-6.15,35.71,35.71,0,0,0,4.69-6.44,9.86,9.86,0,0,0,1-2.55c0-.26,0-.38,0-.32a.18.18,0,0,0,0,.06.14.14,0,0,0,0,.06v0l0-.11-.37-.93a44.36,44.36,0,0,0-9.14-13.67,58.43,58.43,0,0,0-6.32-5.74c-1.12-.88-2.28-1.72-3.44-2.52-.59-.4-1.17-.8-1.76-1.16l-.88-.52-.77-.43Z",
    style: {
      fill: "#278CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.39,148.21c.53.34.83.56,1.21.84l1.06.79c.69.53,1.37,1,2,1.59q2,1.6,3.87,3.32a90.86,90.86,0,0,1,7.17,7.25,71.6,71.6,0,0,1,6.26,8.23c.94,1.47,1.85,3,2.65,4.54a50.71,50.71,0,0,1,2.27,4.83l.49,1.25.06.16.11.31.19.61c.1.41.2.82.26,1.22a13.54,13.54,0,0,1,0,4.33,21.4,21.4,0,0,1-2.14,6.24,52.59,52.59,0,0,1-6,8.93c-2.11,2.67-4.33,5.13-6.58,7.54-1.13,1.2-2.25,2.4-3.41,3.57l-1.75,1.75c-.61.59-1.15,1.15-1.84,1.8L280,206.12c.51-.35,1.15-.82,1.72-1.26l1.74-1.38c1.15-.93,2.3-1.87,3.4-2.87a78.16,78.16,0,0,0,6.19-6.15,35.71,35.71,0,0,0,4.69-6.44,9.86,9.86,0,0,0,1-2.55c0-.26,0-.38,0-.32a.18.18,0,0,0,0,.06.14.14,0,0,0,0,.06v0l0-.11-.37-.93a44.36,44.36,0,0,0-9.14-13.67,58.43,58.43,0,0,0-6.32-5.74c-1.12-.88-2.28-1.72-3.44-2.52-.59-.4-1.17-.8-1.76-1.16l-.88-.52-.77-.43Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Counter--inject-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 105.89,
    y: 246.36,
    width: 296.69,
    height: 12.05,
    style: {
      fill: "#278CFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.89,
    y: 246.36,
    width: 296.69,
    height: 12.05,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.61,
    y: 246.36,
    width: 25.97,
    height: 12.05,
    style: {
      fill: "#278CFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.17,
    y: 258.41,
    width: 286.12,
    height: 156.59,
    style: {
      fill: "#278CFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.17,
    y: 258.41,
    width: 286.12,
    height: 156.59,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.9,
    y: 258.41,
    width: 15.4,
    height: 156.59,
    style: {
      fill: "#278CFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.17,
    y: 258.41,
    width: 286.12,
    height: 3.97,
    style: {
      fill: "#278CFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.95,
    cy: 332.7,
    r: 42.14,
    style: {
      fill: "#278CFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.24,
    cy: 332.7,
    r: 42.14,
    style: {
      fill: "#278CFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242.88,
    cy: 332.7,
    r: 42.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.73,
    y: 307.5,
    width: 14.3,
    height: 50.4,
    rx: 2.85,
    style: {
      fill: "#278CFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.73,
    y: 307.5,
    width: 14.3,
    height: 50.4,
    rx: 2.85,
    transform: "translate(575.58 89.81) rotate(90)",
    style: {
      fill: "#278CFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.37 239.69 307.33 239.69 317.3 191.67 394.33 191.67 384.37 239.69",
    style: {
      fill: "#278CFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.37 239.69 307.33 239.69 317.3 191.67 394.33 191.67 384.37 239.69",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.88 227.75 334.55 227.75 338.84 207.08 371.17 207.08 366.88 227.75",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.62 227.75 334.55 227.75 338.84 207.08 336.91 207.08 332.62 227.75",
    style: {
      fill: "#278CFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.79 218.35 345.99 218.35 346.86 239.69 352.65 239.69 351.79 218.35",
    style: {
      fill: "#278CFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.63 239.69 307.33 239.69 317.3 191.67 318.6 191.67 308.63 239.69",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.79 246.35 365.71 246.35 360.75 217.41 346.83 217.41 351.79 246.35",
    style: {
      fill: "#278CFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.79 246.35 365.71 246.35 360.75 217.41 346.83 217.41 351.79 246.35",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.54 246.35 351.79 246.35 346.83 217.41 345.58 217.41 350.54 246.35",
    style: {
      fill: "#278CFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.54 246.35 351.79 246.35 346.83 217.41 345.58 217.41 350.54 246.35",
    style: {
      fill: "#fff",
      opacity: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.12 244.71 340.26 244.71 337.42 246.35 351.12 246.35 351.12 244.71",
    style: {
      fill: "#278CFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.23,
    y: 226.14,
    width: 18.42,
    height: 20.21,
    style: {
      fill: "#278CFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.67 226.14 208.65 226.14 211.9 221.22 200.92 221.22 197.67 226.14",
    style: {
      fill: "#278CFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.23,
    y: 226.14,
    width: 10.98,
    height: 20.21,
    transform: "translate(391.45 472.5) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.17,
    y: 233.28,
    width: 14.48,
    height: 8.99,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.21 226.14 190.23 226.14 186.98 221.22 197.96 221.22 201.21 226.14",
    style: {
      fill: "#278CFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.21 226.14 190.23 226.14 186.98 221.22 197.96 221.22 201.21 226.14",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtPharmacist2);
export default __webpack_public_path__ + "static/media/art__pharmacist__2.3bcba39447b664d61a7500ab0bffc98a.svg";
export { ForwardRef as ReactComponent };